// extracted by mini-css-extract-plugin
module.exports = {"formArea":"ApplyDeductFeeModal_style_formArea__2J94-","brokerageSum":"ApplyDeductFeeModal_style_brokerageSum__2qq1w"};